import { RecentlySoldPage } from './RecentlySoldPage';

export const recentlySoldRouter = {
  '/@/realtime': RecentlySoldPage, // TODO: path 를 적어주세요.
};
